import { Link } from "react-router-dom";
import { contactInfo } from "../data";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-stone-50 border-t border-stone-200">
      <div className="mx-auto max-w-7xl overflow-hidden px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand and Intro */}
          <div>
            <h3 className="text-lg font-semibold text-stone-900 uppercase tracking-wider mb-4">Juhler Fodpleje</h3>
            <p className="text-stone-600 text-sm leading-relaxed max-w-xs">
              Professionel fodpleje – både i klinik og som udekørende. Lægeexamineret fodplejer med fokus på tryghed, høj faglighed og kvalitet.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-stone-900 uppercase tracking-wider mb-4">Navigation</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-stone-600 hover:text-stone-900 transition-colors">Forside</Link></li>
              <li><Link to="/om-pernille" className="text-sm text-stone-600 hover:text-stone-900 transition-colors">Om Pernille</Link></li>
              <li><Link to="/kontakt" className="text-sm text-stone-600 hover:text-stone-900 transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-semibold text-stone-900 uppercase tracking-wider mb-4">Juridisk</h3>
            <ul className="space-y-3">
              <li><Link to="/samtykke-og-privatliv" className="text-sm text-stone-600 hover:text-stone-900 transition-colors">Samtykke & Privatliv</Link></li>
              <li><Link to="/handelsbetingelser" className="text-sm text-stone-600 hover:text-stone-900 transition-colors">Handelsbetingelser</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-stone-900 uppercase tracking-wider mb-4">Klinik & Service</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-stone-400 shrink-0 mt-0.5" />
                <div className="text-sm text-stone-600 space-y-1">
                  <p><strong className="text-stone-900">Kollund Klinik:</strong> Fjordvænget 9, 6340 Kruså</p>
                  <p><strong className="text-stone-900">Dyreborg Klinik:</strong> Knoldsborgvej 6, 5600 Faaborg</p>
                  <p className="text-xs text-stone-500 pt-1">Klinik & Udekørende i Kruså/Padborg & omegn samt Faaborg/Millinge & omegn</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-stone-400 shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="text-sm text-stone-600 hover:text-stone-900 transition-colors">
                  {contactInfo.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-stone-400 shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-sm text-stone-600 hover:text-stone-900 transition-colors">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-stone-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-center text-xs leading-5 text-stone-500">
            &copy; {new Date().getFullYear()} Juhler Fodpleje. Alle rettigheder forbeholdes.
          </p>
          <div className="flex items-center gap-2">
             <span className="text-[10px] text-stone-400 uppercase tracking-widest leading-none">Lægeexamineret Fodplejer</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
